module.exports = __webpack_public_path__ + "static/send-digital-offers-2b614c285721b0d946c92ae0ef0f7de9.svg";